<template>
  <Slide right :closeOnNavigation="true">
    <router-link class="home link" to="/">
      <span>Home</span>
    </router-link>
    <router-link class="link" to="/portfolio/">
      <span>Portfolio</span>
    </router-link>
    <router-link class="link" to="/our-services/">
      <span>Our Services</span>
    </router-link>
    <router-link class="link" to="/testimonials/">
      <span>Testimonials</span>
    </router-link>
    <router-link class="link" to="/contact-us/">
      <span>Contact Us</span>
    </router-link>
    <a class="btn" href="tel:07842819256"
      >07842 819256
    </a>
  </Slide>
</template>

<script>
import { Slide } from 'vue-burger-menu'

export default {
  name: 'mobile-menu',
  components: {
    Slide
  }
}
</script>

<style lang="scss">
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";

.home.router-link-active {
    text-decoration: none;
    color: $body-text;
  }

.bm-burger-button {
  position: absolute;
  right: 15px !important;
  top: calc(50% - 15px) !important;
  bottom: 0 !important;
  width: 36px;
  height: 30px;
  cursor: pointer;
  display: none;
  @media screen and (max-width: $lg-breakpoint) {
    display: block;
  }
}
.bm-burger-bars {
  background-color: $primary;
}
.line-style {
  position: absolute;
  height: 20%;
  width: 36px;
}
.cross-style {
  position: absolute;
  top: 12px;
  right: 2px;
  cursor: pointer;
}
.bm-cross {
  background: #bdc3c7;
}
.bm-cross-button {
  height: 24px;
  width: 24px;
}
.bm-menu {
  height: 100%; /* 100% Full-height */
  width: 0; /* 0 width - change this with JavaScript */
  position: fixed; /* Stay in place */
  z-index: 1000; /* Stay on top */
  top: 0;
  left: 0;
  background-color: $white; /* Black*/
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 60px; /* Place content 60px from the top */
  transition: 0.5s; /*0.5 second transition effect to slide in the sidenav*/
  box-shadow: inset 4px 0px 0px 0px $primary;
  .link {
    padding-left: 0;
  }
  .btn {
    width: fit-content;
    margin-top: 15px;
    white-space: nowrap !important;
  }
}

.bm-overlay {
  background: $white;
  z-index: 99999999999999999999999999;
}
.bm-item-list {
  margin: 0 0 0 30px;
  font-size: 20px;
}
.bm-item-list > * {
  display: flex;
  text-decoration: none;
}
.bm-item-list > * > span {
  font-weight: 600;
  color: $body-text;
  white-space: nowrap;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/MobileMenu.vue